import {RouteRecordRaw} from 'vue-router';
import orderFormRoutes from './order-form.routes';
import {SettingsRecord} from '../../../records/settings.record';
import {Role} from '../../../records/user.record';

export default <RouteRecordRaw[]>[
    {
        path: 'aggregated-reports',
        name: 'aggregatedRoutesReport',
        component: () => import('../../reports/aggregated-reports/AggregatedReports.vue'),
        props: {}
    },
    {
        path: 'on-time-report',
        name: 'onTimeReport',
        component: () => import('../../reports/on-time-report/OnTimeReport.vue'),
        props: {},
        meta: {
            access: (settings: SettingsRecord) => settings.enableOnTimeReportTab
        }
    },
    {
        path: 'delivery-rate',
        name: 'deliveryRateReport',
        component: () => import('../../reports/delivery-ratings/DeliveryRateReport.vue'),
        children: orderFormRoutes('deliveryRateReport'),
        meta: {
            access: (settings: SettingsRecord) => settings.enableRateDelivery
        },
        props: {}
    },
    {
        path: 'driver-performance',
        name: 'driverPerformanceReport',
        component: () => import('../../reports/driver-performance/DriverPerformanceReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.enablePerformerPerformanceReportTab
        },
        props: {}
    },
    {
        path: 'communications-reports',
        name: 'communicationsReport',
        component: () => import('../../reports/communications-report/CommunicationsReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.communicationsReportTab,
            roles: [Role.ADMIN]
        },
        props: {}
    },
    {
        path: 'vehicle-checks-forms-reports',
        name: 'vehicleChecksForms',
        component: () => import('../../reports/vehicle-checks-report/VehicleChecksListReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.vehicleChecks
        },
        props: {}
    },
    {
        path: 'vehicle-checks-faults-reports',
        name: 'vehicleFaults',
        component: () => import('../../reports/vehicle-faults-report/VehicleChecksFaultsListReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.vehicleChecks
        },
        props: {}
    },
    {
        path: 'order-items-delivery-report',
        name: 'orderItemsReport',
        component: () => import('../../reports/order-items-delivery/OrderItemsDeliveryReport.vue'),
        children: orderFormRoutes('orderItemsReport'),
        meta: {
            access: (settings: SettingsRecord) => settings.enableOrderItemsTab
        },
        props: {}
    },
    {
        path: 'fuel-cost-report',
        name: 'fuelCostReport',
        component: () => import('../../reports/fuel-cost/FuelCostReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.enableLoadingResourcesReportTab
        },
        props: {}
    },
    {
        path: 'daily-runs-report',
        name: 'dailyRunsReport',
        component: () => import('../../reports/daily-runs/DailyRunsReport.vue'),
        meta: {
            access: (settings: SettingsRecord) => settings.enableDailyRunsReportTab
        },
        props: {}
    },
    {
        // Loading Report
        path: 'loading-report',
        name: 'loadingReport',
        component: () => import('../../reports/loading-report/LoadingReport.vue'),
        children: orderFormRoutes('loadingReport'),
        meta: {
            access: (settings: SettingsRecord) => settings.loaderReport
        },
        props: {}
    }
];
